import { useContext } from 'react';
import { AppContext } from 'core/context/app.context';

const useAppContext =() => useContext(AppContext);

export default useAppContext;